import React, { useState, useEffect, useContext, createContext } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';
import { numberFormatter } from '../../../components/formatters/numberFormatter';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button } from 'antd';

import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/creatable';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';
import { FaUserPlus } from "react-icons/fa6";

import Loader from '../../../components/loader/loader';
import CustomerForm from '../../../salesTab/customer/customerForm';
import Item from 'antd/es/list/Item';



function UnitModal(props) {

  const { showModal, toggleModal, title, selectedTab, idRow, selectedIndex, selectedCurrency } = props;

  const { settingData, rateFromToCurrency, salableData } = useContext(DataContext);
  const { tabData, setCart } = useContext(PosCartContext);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState(""); 
  const [isLoading, setIsLoading] = useState(false);

  const cart = tabData[selectedTab].cart;


  useEffect(() => {
    setInputValue("");
  }, [showModal]);

  
  const getCorrectIndex = () => {
    return settingData?.posItemReverse 
      ? cart.length - 1 - selectedIndex 
      : selectedIndex;
  };

  // handle select change
  const handleUnit = (unitName, unitQuantity, unitPrice) => {

    let updatedCart = [...cart]; 
    const correctIndex = getCorrectIndex();
    const item = updatedCart[correctIndex];
    
    updatedCart[correctIndex] = {
      ...updatedCart[correctIndex], 
          unitName: unitName,
          unitQuantity: unitQuantity,
          price: rateFromToCurrency(item.currency, selectedCurrency, unitPrice),
          itemPrice: rateFromToCurrency(item.currency, selectedCurrency, unitPrice) / unitQuantity,
          priceDiscountPercentage: 0,
          priceDiscountAmount: 0,
          netPrice: rateFromToCurrency(item.currency, selectedCurrency, unitPrice),
          totalPrice: rateFromToCurrency(item.currency, selectedCurrency, unitPrice) * (item.netQuantity),
          totalCost:  item.netCost * (unitQuantity * item.netQuantity),
    }

    setCart(updatedCart, selectedTab);
    toggleModal();
  };

  const closeModal = () => {
    toggleModal();
    //setAddedCustomer('');
  }


  const getPriceFromData = (productId) => {
    const getProduct = salableData.find(e => e.id == productId);

    return getProduct.price;
  }

  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static' className='Delete_modal'>
      <Modal.Header style={{ background: "#1d7790" }} closeButton>
        <Modal.Title className="arabicText" style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="arabicText">

        {isLoading &&
          <Loader />
        }

        {!isLoading &&
          <Row className='mb-5'>
            <div
              style={{
                display: 'grid',  // Use CSS Grid
                gridTemplateColumns: 'repeat(3, 1fr)', // 4 equal-width columns
                gridAutoRows: 'minmax(80px, 80px)', // Ensures rows adjust based on content, but stay at least 150px tall
                gap: '5px',  // Space between items (adjust as needed)
              }}
            >

              {idRow?.units?.map((item, index) => (
                <div
                  className="card"
                  key={index}
                  style={{
                    height: '15vh',
                    display: 'flex', 
                    flexDirection: 'column', 
                    justifyContent: 'center', 
                    alignItems: 'center', 
                    backgroundColor: '#a4c436',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleUnit(item?.name, item.quantity, item.price)}
                >
                  {item?.name + ' (' + item.quantity + ')'}
                  <h3>{numberFormatter(item.price)}</h3>
                </div>
              ))}

            </div>
          </Row>
        }



      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" loading={loadingEffect} onClick={closeModal}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }} danger>Done</Button>
        </div>
      </Modal.Footer>

    </Modal>

  );
}

export default UnitModal;
